module.exports = __webpack_public_path__ + "img/intro-lady.e5ab8c21.svg";